import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import tipoSolicitacaoArquivoList from '../../../business-rules/List/Arquivo/tipoSolicitacaoArquivoList'



export const incrementaContSolicitacaoArquivo = ( values ) => {

    if (!values.contSolicitacaoArquivo) {

        values.contSolicitacaoArquivo = 0
    }

    values.contSolicitacaoArquivo++
}



export const processaRegistrosDefaultIniciaisSolicitacaoArquivo = ( values/*, jsonConfiguracao*/ ) => {

    //if (!values.familiaresProcessouRegistrosDefaultIniciaisEducacao) {
    //    values.familiaresProcessouRegistrosDefaultIniciaisEducacao = []
    //}

    if (!values.solicitacaoArquivo) {
        values.solicitacaoArquivo = []
    }
    
    /*
    familiaresList(values)?.forEach( (linhaFamiliaresList, index) => {

        if (
                !pesquisaList(values.familiaresProcessouRegistrosDefaultIniciaisEducacao, linhaFamiliaresList.id).id &&
                //(
                //!linhaFamiliaresList.parentesco ||
                linhaFamiliaresList.parentesco &&
                pesquisaList(parentescoList(true), linhaFamiliaresList.parentesco).gerarEducacao === 'S'
                //)
        ) {

            values.familiaresProcessouRegistrosDefaultIniciaisEducacao.push(
                {
                    id: linhaFamiliaresList.id
                }
            )

            idade = idadeFamiliarDataSimulacao(values, linhaFamiliaresList.id)

            let incluiuEducacaoTipoEducacaoList = false

            const educacaoValoresDefault =
                jsonConfiguracao && jsonConfiguracao.educacaoValoresDefault
                    ?
                        jsonConfiguracao.educacaoValoresDefault
                    :
                        []

            tipoEducacaoList?.forEach( (linhaTipoEducacaoList, index) => {
                if (linhaTipoEducacaoList.valorDefault && 
                    idade <= linhaTipoEducacaoList.idadeFinalDefault) {

                    const linhaEducacaoValoresDefault = pesquisaList(educacaoValoresDefault, linhaTipoEducacaoList.id)

                    incrementaContEducacao(values)
                    values.educacao.push(
                        {
                            id: values.contEducacao,
                            familiar: linhaFamiliaresList.id,
                            tipoEducacao: linhaTipoEducacaoList.id,
                            tipoPeriodicidadePagto: linhaTipoEducacaoList.tipoPeriodicidadePagtoDefault,
                            valor:
                                linhaEducacaoValoresDefault.valor
                                    ?
                                        linhaEducacaoValoresDefault.valor
                                    :
                                        linhaTipoEducacaoList.valorDefault,
                            idadeInicial: 
                                idade >= linhaTipoEducacaoList.idadeInicialDefault 
                                    ? 
                                        idade 
                                    : 
                                        linhaTipoEducacaoList.idadeInicialDefault,
                            idadeFinal: linhaTipoEducacaoList.idadeFinalDefault,
                        }
                    )

                    calculaEducacaoGrupoDespesa(values.educacao[values.educacao.length - 1])

                    incluiuEducacaoTipoEducacaoList = true
                }
            })

            if (!incluiuEducacaoTipoEducacaoList) {
                incrementaContEducacao(values)
                values.educacao.push(
                    {
                        id: values.contEducacao,
                        familiar: linhaFamiliaresList.id,
                    }
                )
            }
        }
    })
    */
}



export const processaValoresDefaultIniciaisSolicitacaoArquivo = ( item ) => {

    if (!item.atribuiuObservacaoSolicitacaoArquivoDefault) {

        const linhaTipoSolicitacaoArquivo =
            pesquisaList(tipoSolicitacaoArquivoList, item.tipoSolicitacaoArquivo)

        if (linhaTipoSolicitacaoArquivo.observacaoSolicitacaoArquivo) {

            item.observacaoSolicitacaoArquivo = linhaTipoSolicitacaoArquivo.observacaoSolicitacaoArquivo
            item.atribuiuObservacaoSolicitacaoArquivoDefault = true
        }
    }
}